import { render, staticRenderFns } from "./SituationSpecificClassification.vue?vue&type=template&id=9493280e&"
import script from "./SituationSpecificClassification.vue?vue&type=script&lang=js&"
export * from "./SituationSpecificClassification.vue?vue&type=script&lang=js&"
import style0 from "./SituationSpecificClassification.vue?vue&type=style&index=0&id=9493280e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports